const testMixin = {
    data() {
        return {
            POSITION_RESOURCES: [1, 2],
            requestSent: false
        }
    },
    methods: {
        finishTest(value = null) {

            if (this.requestSent) return;

            if (value && value.type === 'click') {

                let text = this.getTranslation('cantRevertMsg');

                if (this.$store.getters['candidate/answerCount'] < this.$store.getters['candidate/getQuestionCount'])
                    text = this.getTranslation('youDidNotAnswerAllQuestions');

                Swal.fire({
                    title: this.getTranslation('areYouSure'),
                    text: text,
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: this.getTranslation('cancel'),
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: this.getTranslation('ImSure')
                }).then((result) => {

                    if (result.value) {

                        if (this.requestSent) return;

                        this.requestSent = true;

                        return this.axios.post(this.$config.urls.candidateTesting.finish.url, {
                            accessToken: this.getAccessToken()
                        })
                            .then(async response => {

                                this.requestSent = false;

                                let data = response.data.data;

                                await this.$store.dispatch('candidate/disableTimer');

                                if (data.testing) {

                                    await this.$store.dispatch('candidate/setCurrentTesting', data.candidateTest);

                                    if (data.modal) {

                                        let timerInterval;

                                        Swal.fire({
                                            title: this.getTranslation(data.modal),
                                            timer: 15000,
                                            html: '<h4 class="text-center" >' + this.getTranslation('candidateTestPoint') + ': ' + ' <span class="text--success text--bold" > ' + data.testPoint + '</span></h4>',
                                            footer: data.text ? this.getTranslation(data.text) : this.getTranslation('clickOK'),
                                            showCancelButton: false,
                                            showConfirmButton: true,
                                            timerProgressBar: true,
                                            onBeforeOpen: () => {
                                                timerInterval = setInterval(() => {
                                                }, 1000)
                                            },
                                            onClose: () => {
                                                clearInterval(timerInterval)
                                            }
                                        }).then((result) => {
                                            this.$router.replace({query: {question: '1'}}).catch(() => {
                                            });
                                            this.$root.$emit('nextTest');
                                        })
                                    }
                                } else {
                                    let timerInterval;

                                    Swal.fire({
                                        title: this.getTranslation(data.message),
                                        timer: 15000,
                                        html: '<h4 class="text-center" >' + this.getTranslation('candidateTestPoint') + ': ' + ' <span class="text--success text--bold" > ' + data.testPoint + '</span></h4>',
                                        footer: data.text ? this.getTranslation(data.text) : this.getTranslation('clickOK'),
                                        showCancelButton: false,
                                        showConfirmButton: true,
                                        timerProgressBar: true,
                                        onBeforeOpen: () => {
                                            timerInterval = setInterval(() => {
                                            }, 1000)
                                        },
                                        onClose: () => {
                                            clearInterval(timerInterval)
                                        }
                                    }).then((result) => {
                                        this.resetTesting().then(async () => {
                                            if (data.testingId) {
                                                this.$router.push({name: 'candidate.results', params: {id: data.testingId}}).catch(() => {
                                                });
                                            } else {
                                                await this.$store.dispatch('candidate/setActiveTesting', false);
                                                this.$router.push({name: 'auth.success'}).catch(() => {
                                                });
                                            }
                                        });
                                    })

                                }

                            })
                            .catch(error => {

                                this.requestSent = false;

                                if (error.response && error.response.status === 451)
                                    return;


                                this.resetTesting().then(() => {
                                    this.$router.replace({name: 'auth.success'}).catch(() => {
                                    });
                                });

                            });
                    }
                })
            } else {
                if (this.requestSent) return;

                this.requestSent = true;

                return this.axios.post(this.$config.urls.candidateTesting.finish.url,{
                    accessToken: this.getAccessToken()
                })
                    .then(async response => {

                        let data = response.data.data;
                        await this.$store.dispatch('candidate/disableTimer');

                        if (data.testing) {

                            await this.$store.dispatch('candidate/setCurrentTesting', data.candidateTest);

                            if (data.modal) {
                                let timerInterval;

                                Swal.fire({
                                    title: this.getTranslation(data.modal),
                                    timer: 15000,
                                    html: '<h4 class="text-center" >' + this.getTranslation('candidateTestPoint') + ': ' + ' <span class="text--success text--bold" > ' + data.testPoint + '</span></h4>',
                                    footer: data.text ? this.getTranslation(data.text) : this.getTranslation('clickOK'),
                                    showCancelButton: false,
                                    showConfirmButton: true,
                                    timerProgressBar: true,
                                    onBeforeOpen: () => {
                                        timerInterval = setInterval(() => {
                                        }, 1000)
                                    },
                                    onClose: () => {
                                        clearInterval(timerInterval)
                                    }
                                }).then((result) => {

                                    this.$router.replace({query: {question: '1'}}).catch(() => {
                                    });
                                    this.$root.$emit('nextTest');

                                }).catch(() => {
                                    this.snotifyError('errorAskAdmin', null, 5000);
                                })
                            }
                        } else {
                            let timerInterval;

                            Swal.fire({
                                title: this.getTranslation(data.message),
                                timer: 15000,
                                html: '<h4 class="text-center" >' + this.getTranslation('candidateTestPoint') + ': ' + ' <span class="text--success text--bold" > ' + data.testPoint + '</span></h4>',
                                footer: data.text ? this.getTranslation(data.text) : this.getTranslation('clickOK'),
                                showCancelButton: false,
                                showConfirmButton: true,
                                timerProgressBar: true,
                                onBeforeOpen: () => {
                                    timerInterval = setInterval(() => {
                                    }, 1000)
                                },
                                onClose: () => {
                                    clearInterval(timerInterval)
                                }
                            }).then((result) => {

                                this.resetTesting().then(() => {
                                    if (data.testingId) {
                                        this.$router.push({name: 'candidate.results', params: {id: data.testingId}}).catch(() => {
                                        });
                                    } else {
                                        this.$router.push({name: 'auth.success'}).catch(() => {
                                        });
                                    }
                                });

                            }).catch(() => {
                                this.snotifyError('errorAskAdmin', null, 5000);
                            })

                        }

                        this.requestSent = false;

                    })
                    .catch(error => {

                        this.requestSent = false;

                        if (error.response && error.response.status === 451)
                            return;


                        this.resetTesting().then(() => {
                            this.$router.replace({name: 'auth.success'}).catch(() => {
                            });
                        });

                    })
            }
        },
        async resetTesting() {
            await this.$store.dispatch('candidate/disableTimer');
            await this.$store.dispatch('candidate/setActiveTesting', false);
            await this.$store.dispatch('candidate/resetCurrentTesting');
        }
    }
};

export default testMixin;
